import { render, staticRenderFns } from "./Forgetpwd.vue?vue&type=template&id=f39548ba&scoped=true"
import script from "./Forgetpwd.vue?vue&type=script&lang=js"
export * from "./Forgetpwd.vue?vue&type=script&lang=js"
import style0 from "./Forgetpwd.vue?vue&type=style&index=0&id=f39548ba&prod&lang=less&scoped=true"
import style1 from "./Forgetpwd.vue?vue&type=style&index=1&id=f39548ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39548ba",
  null
  
)

export default component.exports